module.exports = __webpack_public_path__ + "static/the-willpower-instinct-b45236b7c0923483e43a4d4b6f24c7e8.jpg";